import React from "react";
import { Box, styled, Typography } from "@material-ui/core";
import { BrandsListSectionFragment_brands } from "./__generated__/BrandsListSectionFragment";
import LocalizedLink from "../../components/localized-link";
import { Background as ImgixBackground } from "react-imgix";

export const WrapperLink = styled(LocalizedLink)(({ theme }) => ({
  display: "flex",
  position: "relative",
  overflow: "hidden",
  borderRadius: "8px",
  // Xsmall: 1 columns
  [theme.breakpoints.only("xs")]: {
    width: "calc(100vw - 32px - 12px - 64px)",
    height: "calc((100vw - 32px - 12px - 64px) * 1.5)",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(1.5)
    }
  },
  // Sm: 2 columns
  [theme.breakpoints.only("sm")]: {
    width: "calc(((100vw - 48px - (16px * 1) ) / 2) - 32px)",
    height: "calc((((100vw - 48px - (16px * 1) ) / 2)) * 1.5)",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(2)
    }
  },
  // Md: 3 columns
  [theme.breakpoints.only("md")]: {
    width: "calc((((100vw - 64px - (16px * 2) ) / 3)) - 12px)",
    height: "calc((((100vw - 64px - (16px * 2) ) / 3)) * 1.5)",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(2)
    }
  },
  // Lg+: 4 columns
  [theme.breakpoints.up("lg")]: {
    width: "calc(((min(1920px, 100vw) - 128px - (24px * 3) ) / 4) - 12px)",
    height: "calc((((min(1920px, 100vw) - 128px - (24px * 3) ) / 4)) * 1.5)",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  },
  // Lg+: 4 columns
  [theme.breakpoints.up("xl")]: {
    width: "calc(((min(1920px, 100vw) - 128px - (24px * 3) ) / 4))",
    height: "calc((((min(1920px, 100vw) - 128px - (24px * 3) ) / 4)) * 1.5)",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  }
}));

export const CustomImgixBackground = styled(ImgixBackground)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: theme.palette.grey[300],
  borderRadius: "8px",
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end"
}));

type Props = BrandsListSectionFragment_brands;

function BrandCard({ brand, subtitle, image, color }: Props) {
  return (
    <WrapperLink to={`/shop/${brand.slug}`}>
      <CustomImgixBackground src={image.url}>
        <Box mb={subtitle ? 1 : 0}>
          <Typography
            variant="h5"
            className={color === "white" ? "white" : null}
          >
            {brand.name}
          </Typography>
        </Box>
        {subtitle && (
          <Typography
            variant="caption"
            className={color === "white" ? "white" : null}
          >
            {subtitle}
          </Typography>
        )}
      </CustomImgixBackground>
    </WrapperLink>
  );
}

export default React.memo(BrandCard);
